// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableView_table-view__qaVhh {
  width: 100%;
  overflow-x: auto;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.TableView_table-view__qaVhh table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
}
.TableView_table-view__group--research__nHpYG {
  background: rgba(0, 168, 181, 0.12);
  color: #00838f;
  border-bottom-color: #00a8b5 !important;
}
.TableView_table-view__group--funding__nyrDb {
  background: rgba(156, 39, 176, 0.1);
  color: #7b1fa2;
  border-bottom-color: #9c27b0 !important;
}
.TableView_table-view__checkbox__vh6Uo {
  width: 40px;
  text-align: center;
  position: sticky;
  left: 0;
  z-index: 2;
  background: #fff;
}
.TableView_table-view__checkbox__vh6Uo input[type=checkbox] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--accent-color);
}
.TableView_table-view__rank__l96n0 {
  font-weight: 700;
  color: var(--accent-color);
  font-size: 16px;
  width: 50px;
  position: sticky;
  left: 40px;
  z-index: 2;
  background: #fff;
}
.TableView_table-view__university__eSl4R {
  min-width: 200px;
  position: sticky;
  left: 90px;
  z-index: 2;
  background: #fff;
  border-right: 1px solid rgba(0, 0, 0, 0.06);
}
.TableView_table-view__university-info__2d2Mu {
  display: flex;
  align-items: center;
  gap: 12px;
}
.TableView_table-view__col-header__sIbns th {
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 600;
  color: var(--grey-text);
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  white-space: nowrap;
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  background: var(--background-color-1);
}
.TableView_table-view__col-header__sIbns th .TableView_sort-icon__w7wTC {
  display: inline-block;
  margin-left: 4px;
  font-size: 10px;
  opacity: 0.5;
}
.TableView_table-view__col-header__sIbns th:nth-child(1) {
  position: sticky;
  left: 0;
  z-index: 3;
  background: var(--background-color-1);
}
.TableView_table-view__col-header__sIbns th:nth-child(2) {
  position: sticky;
  left: 40px;
  z-index: 3;
  background: var(--background-color-1);
}
.TableView_table-view__col-header__sIbns th:nth-child(3) {
  position: sticky;
  left: 90px;
  z-index: 3;
  background: var(--background-color-1);
  border-right: 1px solid rgba(0, 0, 0, 0.06);
}
.TableView_table-view__group-header__Ku6Vo th {
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.3px;
  border-bottom: 2px solid transparent;
}
.TableView_table-view__group-header__Ku6Vo th:first-child {
  position: sticky;
  left: 0;
  z-index: 3;
  background: #fff;
}
.TableView_table-view__row__3KVm4 {
  transition: background 0.2s;
}
.TableView_table-view__row__3KVm4:hover {
  background: rgba(0, 0, 0, 0.02);
}
.TableView_table-view__row__3KVm4:hover td[class*=checkbox],
.TableView_table-view__row__3KVm4:hover td[class*=rank],
.TableView_table-view__row__3KVm4:hover td[class*=university] {
  background: #fafafa;
}
.TableView_table-view__row__3KVm4 td {
  padding: 14px 12px;
  font-size: 14px;
  color: var(--text-1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  vertical-align: middle;
}
.TableView_table-view__logo__\\+nHKu {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  background: var(--accent-color-light);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: var(--accent-color);
  flex-shrink: 0;
}
.TableView_table-view__logo-img__SWzmK {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  object-fit: contain;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}
.TableView_table-view__uni-text__pJ9wD {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.TableView_table-view__uni-name__JdkWH {
  font-weight: 600;
  color: var(--accent-color);
  font-size: 14px;
}
.TableView_table-view__uni-meta__n\\+TiT {
  font-size: 11px;
  color: var(--grey-text);
}
.TableView_table-view__num__6OS\\+f {
  font-variant-numeric: tabular-nums;
  font-weight: 500;
}
.TableView_table-view__bar-cell__VAtxL .TableView_value__MIlrp {
  font-weight: 600;
  font-size: 15px;
  display: flex;
  align-items: baseline;
  gap: 2px;
}
.TableView_table-view__bar-cell__VAtxL .TableView_value__MIlrp sub {
  font-size: 10px;
  font-weight: 400;
  color: var(--grey-text);
}
.TableView_table-view__bar-cell__VAtxL .TableView_bar__m0MhD {
  margin-top: 4px;
  width: 80px;
  height: 5px;
  background: #e8edf2;
  border-radius: 3px;
  overflow: hidden;
}
.TableView_table-view__bar-cell__VAtxL .TableView_bar__fill__WN7da {
  height: 100%;
  border-radius: 3px;
  background: linear-gradient(90deg, #0f3460, #4a6fa5);
  transition: width 0.5s ease;
}
.TableView_table-view__actions__ADndf {
  display: flex;
  gap: 14px;
  align-items: center;
}
.TableView_table-view__action__6PGEn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  cursor: pointer;
  color: var(--grey-text);
  transition: color 0.2s;
}
.TableView_table-view__action__6PGEn svg {
  width: 18px;
  height: 18px;
}
.TableView_table-view__action__6PGEn span {
  font-size: 9px;
}
.TableView_table-view__action__6PGEn:hover {
  color: var(--accent-color-dark);
}
.TableView_table-view__currency__0b9hg {
  font-weight: 600;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Benchmarking/Components/TableView/TableView.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;EACA,mCAAA;EACA,qCAAA;AACF;AACE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AACJ;AAGE;EACE,mCAAA;EACA,cAAA;EACA,uCAAA;AADJ;AAIE;EACE,mCAAA;EACA,cAAA;EACA,uCAAA;AAFJ;AAME;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;AAJJ;AAMI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAJN;AAQE;EACE,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;AANJ;AASE;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,2CAAA;AAPJ;AASI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAPN;AAaI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,4CAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qCAAA;AAXN;AAaM;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAXR;AAeM;EACE,gBAAA;EACA,OAAA;EACA,UAAA;EACA,qCAAA;AAbR;AAeM;EACE,gBAAA;EACA,UAAA;EACA,UAAA;EACA,qCAAA;AAbR;AAeM;EACE,gBAAA;EACA,UAAA;EACA,UAAA;EACA,qCAAA;EACA,2CAAA;AAbR;AAoBI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oCAAA;AAlBN;AAoBM;EACE,gBAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;AAlBR;AAwBE;EACE,2BAAA;AAtBJ;AAwBI;EACE,+BAAA;AAtBN;AAwBM;;;EAGE,mBAAA;AAtBR;AA0BI;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,4CAAA;EACA,sBAAA;AAxBN;AA4BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;AA1BJ;AA6BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;EACA,cAAA;AA3BJ;AA8BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA5BJ;AA+BE;EACE,gBAAA;EACA,0BAAA;EACA,eAAA;AA7BJ;AAgCE;EACE,eAAA;EACA,uBAAA;AA9BJ;AAkCE;EACE,kCAAA;EACA,gBAAA;AAhCJ;AAqCI;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;AAnCN;AAqCM;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAnCR;AAuCI;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AArCN;AAuCM;EACE,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,2BAAA;AArCR;AA2CE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAzCJ;AA4CE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;AA1CJ;AA4CI;EACE,WAAA;EACA,YAAA;AA1CN;AA6CI;EACE,cAAA;AA3CN;AA8CI;EACE,+BAAA;AA5CN;AAiDE;EACE,gBAAA;EACA,mBAAA;AA/CJ","sourcesContent":[".table-view {\n  width: 100%;\n  overflow-x: auto;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 1000px;\n  }\n\n\n  &__group--research {\n    background: rgba(0, 168, 181, 0.12);\n    color: #00838f;\n    border-bottom-color: #00a8b5 !important;\n  }\n\n  &__group--funding {\n    background: rgba(156, 39, 176, 0.10);\n    color: #7b1fa2;\n    border-bottom-color: #9c27b0 !important;\n  }\n\n  // cells\n  &__checkbox {\n    width: 40px;\n    text-align: center;\n    position: sticky;\n    left: 0;\n    z-index: 2;\n    background: #fff;\n\n    input[type=\"checkbox\"] {\n      width: 16px;\n      height: 16px;\n      cursor: pointer;\n      accent-color: var(--accent-color);\n    }\n  }\n\n  &__rank {\n    font-weight: 700;\n    color: var(--accent-color);\n    font-size: 16px;\n    width: 50px;\n    position: sticky;\n    left: 40px;\n    z-index: 2;\n    background: #fff;\n  }\n\n  &__university {\n    min-width: 200px;\n    position: sticky;\n    left: 90px;\n    z-index: 2;\n    background: #fff;\n    border-right: 1px solid rgba(0, 0, 0, 0.06);\n\n    &-info {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n    }\n  }\n\n  // sticky header cells need same treatment\n  &__col-header {\n    th {\n      padding: 10px 12px;\n      font-size: 12px;\n      font-weight: 600;\n      color: var(--grey-text);\n      text-align: left;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n      white-space: nowrap;\n      cursor: default;\n      user-select: none;\n      background: var(--background-color-1);\n\n      .sort-icon {\n        display: inline-block;\n        margin-left: 4px;\n        font-size: 10px;\n        opacity: 0.5;\n      }\n\n      // sticky header columns\n      &:nth-child(1) {\n        position: sticky;\n        left: 0;\n        z-index: 3;\n        background: var(--background-color-1);\n      }\n      &:nth-child(2) {\n        position: sticky;\n        left: 40px;\n        z-index: 3;\n        background: var(--background-color-1);\n      }\n      &:nth-child(3) {\n        position: sticky;\n        left: 90px;\n        z-index: 3;\n        background: var(--background-color-1);\n        border-right: 1px solid rgba(0, 0, 0, 0.06);\n      }\n    }\n  }\n\n  // sticky group header cells\n  &__group-header {\n    th {\n      padding: 8px 12px;\n      font-size: 13px;\n      font-weight: 700;\n      text-align: center;\n      letter-spacing: 0.3px;\n      border-bottom: 2px solid transparent;\n\n      &:first-child {\n        position: sticky;\n        left: 0;\n        z-index: 3;\n        background: #fff;\n      }\n    }\n  }\n\n  // row hover needs to update sticky cell backgrounds\n  &__row {\n    transition: background 0.2s;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.02);\n\n      td[class*=\"checkbox\"],\n      td[class*=\"rank\"],\n      td[class*=\"university\"] {\n        background: #fafafa;\n      }\n    }\n\n    td {\n      padding: 14px 12px;\n      font-size: 14px;\n      color: var(--text-1);\n      border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n      vertical-align: middle;\n    }\n  }\n\n  &__logo {\n    width: 48px;\n    height: 48px;\n    border-radius: 6px;\n    background: var(--accent-color-light);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--accent-color);\n    flex-shrink: 0;\n  }\n\n  &__logo-img {\n    width: 48px;\n    height: 48px;\n    border-radius: 6px;\n    object-fit: contain;\n    background: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    flex-shrink: 0;\n  }\n\n  &__uni-text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  &__uni-name {\n    font-weight: 600;\n    color: var(--accent-color);\n    font-size: 14px;\n  }\n\n  &__uni-meta {\n    font-size: 11px;\n    color: var(--grey-text);\n  }\n\n  // numeric cells\n  &__num {\n    font-variant-numeric: tabular-nums;\n    font-weight: 500;\n  }\n\n  // progress-bar cell\n  &__bar-cell {\n    .value {\n      font-weight: 600;\n      font-size: 15px;\n      display: flex;\n      align-items: baseline;\n      gap: 2px;\n\n      sub {\n        font-size: 10px;\n        font-weight: 400;\n        color: var(--grey-text);\n      }\n    }\n\n    .bar {\n      margin-top: 4px;\n      width: 80px;\n      height: 5px;\n      background: #e8edf2;\n      border-radius: 3px;\n      overflow: hidden;\n\n      &__fill {\n        height: 100%;\n        border-radius: 3px;\n        background: linear-gradient(90deg, #0f3460, #4a6fa5);\n        transition: width 0.5s ease;\n      }\n    }\n  }\n\n  // actions cell\n  &__actions {\n    display: flex;\n    gap: 14px;\n    align-items: center;\n  }\n\n  &__action {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1px;\n    cursor: pointer;\n    color: var(--grey-text);\n    transition: color 0.2s;\n\n    svg {\n      width: 18px;\n      height: 18px;\n    }\n\n    span {\n      font-size: 9px;\n    }\n\n    &:hover {\n      color: var(--accent-color-dark);\n    }\n  }\n\n  // currency/large\n  &__currency {\n    font-weight: 600;\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table-view": `TableView_table-view__qaVhh`,
	"table-view__group--research": `TableView_table-view__group--research__nHpYG`,
	"table-view__group--funding": `TableView_table-view__group--funding__nyrDb`,
	"table-view__checkbox": `TableView_table-view__checkbox__vh6Uo`,
	"table-view__rank": `TableView_table-view__rank__l96n0`,
	"table-view__university": `TableView_table-view__university__eSl4R`,
	"table-view__university-info": `TableView_table-view__university-info__2d2Mu`,
	"table-view__col-header": `TableView_table-view__col-header__sIbns`,
	"sort-icon": `TableView_sort-icon__w7wTC`,
	"table-view__group-header": `TableView_table-view__group-header__Ku6Vo`,
	"table-view__row": `TableView_table-view__row__3KVm4`,
	"table-view__logo": `TableView_table-view__logo__+nHKu`,
	"table-view__logo-img": `TableView_table-view__logo-img__SWzmK`,
	"table-view__uni-text": `TableView_table-view__uni-text__pJ9wD`,
	"table-view__uni-name": `TableView_table-view__uni-name__JdkWH`,
	"table-view__uni-meta": `TableView_table-view__uni-meta__n+TiT`,
	"table-view__num": `TableView_table-view__num__6OS+f`,
	"table-view__bar-cell": `TableView_table-view__bar-cell__VAtxL`,
	"value": `TableView_value__MIlrp`,
	"bar": `TableView_bar__m0MhD`,
	"bar__fill": `TableView_bar__fill__WN7da`,
	"table-view__actions": `TableView_table-view__actions__ADndf`,
	"table-view__action": `TableView_table-view__action__6PGEn`,
	"table-view__currency": `TableView_table-view__currency__0b9hg`
};
export default ___CSS_LOADER_EXPORT___;
